export default __webpack_public_path__ + "static/diana-7a3b511a55ceba89c537e95d64bdf372.jpg";